import { matchPath } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import { routes, sentryDsn } from "./constants";
import history from "./history";
import { getCurrentVersionQuickly } from "../components/hooks/appVersionHooks";
import { INSTALLED_VERSION_UNKNOWN } from "../redux/models/refsixState";
import { AdMobService } from "../services/AdMobService";
import { store } from "../redux/store";
import { initUXCamSession } from "../services/analytics/uxCamSession";
import { installMockUXCam } from "../services/analytics/mockUXCam";
import { installMockInAppBrowser } from "../services/assignments/mockInAppBrowser";

const routePaths = Object.values(routes).map((path) => ({ path }));

export const AppInit = async () => {
    Sentry.init({
        dsn: sentryDsn,
        integrations: [
            new BrowserTracing({
                routingInstrumentation: Sentry.reactRouterV5Instrumentation(
                    history,
                    routePaths,
                    matchPath
                ),
            }),
        ],
        tracesSampleRate: 0, // 20% of transactions sampled
        environment: process.env.NODE_ENV,
        normalizeDepth: 10, // depth of redux state to log
    });

    Sentry.configureScope(function (scope) {
        scope.addEventProcessor((event) => {
            return new Promise(async (resolve) => {
                try {
                    const version = await getCurrentVersionQuickly();
                    const eventWithAppVersion = {
                        ...event,
                        release:
                            version === INSTALLED_VERSION_UNKNOWN
                                ? undefined
                                : version,
                    };
                    return resolve(eventWithAppVersion);
                } catch (e) {
                    console.log("Error getting app version", e);
                    return resolve(event);
                }
            });
        });
    });

    AdMobService.getInstance();

    // REFSIX-776: start session replay on app open, whatever the auth state,
    // and keep the account attached to it as the store changes. The mock must
    // be registered first — it stands in for the native plugin on web/Cypress,
    // where UXCam is otherwise entirely invisible.
    installMockUXCam();
    installMockInAppBrowser();
    initUXCamSession(store);
};
